import { render } from "./ManageKPI.vue?vue&type=template&id=15d1c172&scoped=true"
import script from "./ManageKPI.vue?vue&type=script&lang=js"
export * from "./ManageKPI.vue?vue&type=script&lang=js"

import "./ManageKPI.vue?vue&type=style&index=0&id=15d1c172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d1c172"]])

export default __exports__